import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAppDispatch } from 'hooks/useAppDispatch';
import {
  useGetVerificationStatusEmployment,
  useGetVerificationStatusInvestorLevel,
  useSubmitVerificationEmployment,
  useSubmitVerificationLevel,
} from 'hooks/useGetVerificationStatus';
import {
  getVerificationStatusEmploymentAction,
  getVerificationStatusInvestorLevelAction,
} from 'store/verification/verification-actions';
import {
  SubmitVerificationInfo,
  VerificationStatusResponse,
} from 'types/verification';
import verificationStatus from '../../../../data/verificationStatus';
import { EmploymentState } from './EmploymentState';
import EmploymentView from './components/EmploymentView';

export const Route = createFileRoute('/_authenticated/verification/employment')({
  component: Employment,
});

function Employment() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const employmentInfo = useGetVerificationStatusEmployment();
  const investorLevelInfo = useGetVerificationStatusInvestorLevel();
  const [submitVerificationEmployment] = useSubmitVerificationEmployment();
  const [submitVerificationLevel] = useSubmitVerificationLevel();
  const responses: VerificationStatusResponse[] = [];

  function addCallback(response: VerificationStatusResponse) {
    responses.push(response);
  }

  async function submitForm(viewState: EmploymentState) {
    const requestEmp: SubmitVerificationInfo = {
      fields: [],
      callback: addCallback,
    };
    const requestLevel: SubmitVerificationInfo = {
      fields: [],
      callback: addCallback,
    };

    employmentInfo.requiredSubmissionFields.forEach(field => {
      requestEmp.fields.push({ key: field, value: viewState.employment });
    });

    investorLevelInfo.requiredSubmissionFields.forEach(field => {
      requestLevel.fields.push({ key: field, value: viewState.investorLevel });
    });

    await Promise.all([
      submitVerificationEmployment(requestEmp),
      submitVerificationLevel(requestLevel),
    ]);

    if (
      responses.filter(x => x.statusCode !== verificationStatus.Verified)
        .length === 0
    ) {
      dispatch(getVerificationStatusEmploymentAction());
      dispatch(getVerificationStatusInvestorLevelAction());
      navigate({ to: '/verification/source-of-funds' });
    }
  }

  return (
    <EmploymentView
      employmentInfo={employmentInfo}
      investorLevelInfo={investorLevelInfo}
      onComplete={submitForm}
    />
  );
}

export default Employment;
